import { TypedTranslation } from '../../../../../translation/types';

enum BetRecommendationsBetTextKeys {
	LIVE_LABEL = 'SPORTSBOOK_LIVE_LABEL',
	BET_RECOMMENDATIONS_STATUS_TITLE = 'SPORTSBOOK_BET_RECOMMENDATIONS_STATUS_TITLE',
	BET_RECOMMENDATIONS_STATUS_INFO = 'SPORTSBOOK_BET_RECOMMENDATIONS_STATUS_INFO',
	BET_RECOMMENDATIONS_TITLE_MULTI_SPORT = 'SPORTSBOOK_BET_RECOMMENDATIONS_TITLE_MULTI_SPORT',
	BET_RECOMMENDATIONS_TITLE_COMBO_X = 'SPORTSBOOK_BET_RECOMMENDATIONS_TITLE_COMBO_X'
}

export const BET_RECOMMENDATIONS_TEXT_KEYS = Object.values(BetRecommendationsBetTextKeys);

export type BetRecommendationsTranslations = Readonly<TypedTranslation<typeof BetRecommendationsBetTextKeys>>;

export default BetRecommendationsBetTextKeys;
